import _defineProperty from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/defineProperty";

var assign = require("lodash/assign");

export function MatchQuery(field, query) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!query || !field) {
    return;
  }

  return {
    match: _defineProperty({}, field, assign({
      query: query
    }, options))
  };
}